module.exports = __webpack_public_path__ + "static/media/info02_L.7ce99a92.png";